'use client';

import React__default from 'react';
import { CalendarHeader, ButtonGroup, TittleHeader, ContentWrap } from '../styles.css.js';
import { ECalendarType, ECalendarStyle } from '../types.js';
import { useCalendar } from '../context/calendar.js';
import Button from '../../Button/index.js';
import { DoubleArrowLeft, ArrowLeft, ArrowRight, DoubleArrowRight } from '../../Images/Arrows/index.js';
import { FIRST_DAY } from '../const.js';
import { getFullYear, getMonth } from '../utils/calendar.js';
import { colors } from '../../Colors/index.js';
import Typography from '../../Typography/index.js';

function HeaderCalendar(_a) {
    var onClickNext = _a.onClickNext, onClickPrev = _a.onClickPrev, onClickSupperNext = _a.onClickSupperNext, onClickSupperPrev = _a.onClickSupperPrev;
    var _b = useCalendar(), currentDate = _b.currentDate, calendarStyle = _b.calendarStyle, year = _b.year, setYear = _b.setYear, langCode = _b.langCode, setCalendarType = _b.setCalendarType, calendarType = _b.calendarType;
    var currentYear = getFullYear(currentDate);
    var currentMonth = getMonth(currentDate);
    var newDate = new Date(currentYear, currentMonth + 1, FIRST_DAY);
    var startYear = year - 6;
    var endYear = startYear + 11;
    var renderTitleSingleCalendar = function () {
        var _a;
        switch (calendarType) {
            case ECalendarType.year:
                return (React__default.createElement(ContentWrap, null,
                    React__default.createElement(Typography, { color: colors.grey[20], name: 'title', size: 'medium' }, currentYear)));
            case ECalendarType.decade:
                return (React__default.createElement(ContentWrap, null,
                    React__default.createElement("div", null,
                        React__default.createElement(Typography, { color: colors.grey[20], name: 'title', size: 'medium' },
                            React__default.createElement("span", null, startYear),
                            " - ",
                            React__default.createElement("span", null, endYear)))));
            default:
                return (React__default.createElement(ContentWrap, null,
                    React__default.createElement(Typography, { color: colors.grey[20], name: 'title', size: 'medium' }, (_a = currentDate === null || currentDate === void 0 ? void 0 : currentDate.toLocaleString(langCode, {
                        month: 'short',
                        year: 'numeric'
                    })) !== null && _a !== void 0 ? _a : '')));
        }
    };
    var renderTitleRangeCalendar = function () {
        var _a, _b;
        switch (calendarType) {
            case ECalendarType.year:
                return (React__default.createElement(ContentWrap, null,
                    React__default.createElement("span", null, currentYear),
                    React__default.createElement("span", null, currentYear + 1)));
            default:
                return (React__default.createElement(ContentWrap, null,
                    React__default.createElement("span", null, (_a = currentDate === null || currentDate === void 0 ? void 0 : currentDate.toLocaleDateString(langCode, {
                        month: 'short',
                        year: 'numeric'
                    })) !== null && _a !== void 0 ? _a : ''),
                    React__default.createElement("span", null, (_b = newDate === null || newDate === void 0 ? void 0 : newDate.toLocaleDateString(langCode, {
                        month: 'short',
                        year: 'numeric'
                    })) !== null && _b !== void 0 ? _b : '')));
        }
    };
    var handleChangeCalendarType = function () {
        switch (calendarType) {
            case ECalendarType.month:
                setCalendarType(ECalendarType.year);
                break;
            case ECalendarType.year:
                setCalendarType(ECalendarType.decade);
                break;
            case ECalendarType.decade:
                break;
        }
    };
    return (React__default.createElement(CalendarHeader, null,
        React__default.createElement(ButtonGroup, null,
            React__default.createElement(Button, { size: 'xs', isRounded: true, isIcon: true, type: 'transparent', onClick: function () {
                    onClickSupperPrev();
                    if (calendarType === ECalendarType.decade) {
                        setYear(year - 12);
                    }
                } },
                React__default.createElement(DoubleArrowLeft, { color: colors.grey[40] })),
            calendarType === ECalendarType.month && (React__default.createElement(Button, { size: 'xs', isRounded: true, isIcon: true, type: 'transparent', onClick: onClickPrev },
                React__default.createElement(ArrowLeft, { color: colors.grey[40] })))),
        React__default.createElement(TittleHeader, { onClick: handleChangeCalendarType }, calendarStyle === ECalendarStyle.single ? renderTitleSingleCalendar() : renderTitleRangeCalendar()),
        React__default.createElement(ButtonGroup, null,
            calendarType === ECalendarType.month && (React__default.createElement(Button, { size: 'xs', isRounded: true, isIcon: true, type: 'transparent', onClick: onClickNext },
                React__default.createElement(ArrowRight, { color: colors.grey[40] }))),
            React__default.createElement(Button, { size: 'xs', isRounded: true, isIcon: true, type: 'transparent', onClick: function () {
                    onClickSupperNext();
                    if (calendarType === ECalendarType.decade) {
                        setYear(year + 12);
                    }
                } },
                React__default.createElement(DoubleArrowRight, { color: colors.grey[40] })))));
}

export { HeaderCalendar as default };
//# sourceMappingURL=header.js.map
